import styled from "styled-components";
import { Button } from "reactstrap";

export const StepTexth4 = styled.h3`
  margin: 0;
  text-align: center;
  color: #0c2b6e;
  @media (max-width: 768px) {
    font-size: 20px;
  }

  @media (max-width: 480px) {
    font-size: 18px;
  }
`;
export const ModalWrapper = styled.div`
  position: fixed;
  top: 10%;
  left: 50%;

  transform: none;

  width: 750px;
  max-width: 900px;

  min-height: 25vh;
  max-height: 85vh;

  overflow-y: auto;

  background-color: #f8f9fa;
  border: 1px solid #ddd;
  border-radius: 15px;
  padding: 25px;
  box-shadow: 0px 4px 15px rgba(0, 0, 0, 0.61);
  z-index: 1000;

  display: flex;
  flex-direction: column;

  margin-left: -375px; /* metade do width */
`;

export const StepContainer = styled.div`
  margin: 10px 0;

  justify-content: center;
  width: 100%;

  @media (max-width: 768px) {
    margin: 8px 0;
  }

  @media (max-width: 480px) {
    margin: 5px 0;
  }
`;

export const ButtonNext = styled(Button)`
  width: 15%;
  padding: 10px 25px;
  border-radius: 4px;
  border: none;
  font-size: 18px;
  font-weight: 600;
  background-color: #0c2b6e;
  margin-top: 20px;
  height: 38px;
  display: flex;
  justify-content: center;
  align-items: center;

  @media (max-width: 768px) {
    width: 40%;
    font-size: 16px;
  }

  @media (max-width: 480px) {
    width: 60%;
    font-size: 14px;
  }
`;
